module.exports = __webpack_public_path__ + "images/banners/pages_iphone/logo_2bff252cd3f87625937bb370289c7e12.png";